var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      !_vm.$root.ingredients
        ? _c("news", { attrs: { id: _vm.$root.settings.idForSection } })
        : _vm._e(),
      _vm.$root.ingredients
        ? _c("ingredients", { attrs: { id: _vm.$root.settings.idForSection } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }